export const yearFormat = 'yyyy';
export const monthFormat = 'MM';
export const dateFormat = { full: `${yearFormat}-${monthFormat}`, friendly: `MMMM ${yearFormat}` };
export const shortWeekDays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
export const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
